export enum SankeyNodeType {
  Anchor = `ANCHOR`,
  Dropoff = `DROPOFF`,
  Pruned = `PRUNED`,
  Event = `EVENT`,
}

export const SankeyNodeTypePriority = {
  [SankeyNodeType.Dropoff]: 0,
  [SankeyNodeType.Pruned]: 1,
  [SankeyNodeType.Event]: 2,
  [SankeyNodeType.Anchor]: 2,
};
